import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SignInFlowComponent } from '@auth-n/sign-in-flow/sign-in-flow.component';
import { AuthLayoutComponent } from '@app/app-layout/auth-n/layout/auth-layout.component';

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SignInFlowComponent, AuthLayoutComponent]
})
export class SignInComponent {}
